import React from 'react';
import { FormattedNumber } from 'react-intl';

import DataRow from 'components/Shared/DataRow/DataRow';
import { fontSize } from 'styles/cp';

interface ForcedAutopayPaymentDetailsProps {
  balance: number;
  currency: string;
  companyName: string;
  emailFromSale?: string;
  paymentMethod?: string;
}

const ForcedAutopayPaymentDetails: React.FC<ForcedAutopayPaymentDetailsProps> = ({
  balance,
  currency,
  companyName,
  emailFromSale,
  paymentMethod,
}) => {
  return (
    <>
      {emailFromSale && <DataRow idValue="EMAIL" defaultMessage="Email" value={emailFromSale} />}
      <DataRow idValue="MERCHANT" defaultMessage="Business" value={companyName} />
      {paymentMethod && (
        <DataRow
          idValue="PAYFLOW_PAYMENT_METHOD"
          defaultMessage="Payment method"
          value={paymentMethod}
        />
      )}
      <DataRow
        idValue="TOTAL"
        defaultMessage="Total"
        bold={true}
        fontSize={fontSize.xs}
        value={<FormattedNumber value={balance} style="currency" currency={currency} />}
      />
    </>
  );
};

export default ForcedAutopayPaymentDetails;
